// Module imports
import { Injectable } from '@angular/core';
import { environment } from "../../../../environments/environment";

import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'mapfre-auditlib';
import { filter } from 'rxjs/operators';

/**
 * Prediction personnel service
 */
@Injectable({
  providedIn: 'root'
})
export class WorkersService {

  /**
   * Component constructor
   */
  constructor(private http: HttpClient, private authService: AuthService) { }

  className = 'WorkersService';

  /**
   * Get all personnel predictions
   */

  getAllPersonnelPredictions(orgStructId = '', exercise = null): Observable<any[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    let params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<any[]>(environment.base_URL + `/personnel-predictions`, { params })
  }

  /**
   * Get all personnel predictions
   */
  getAllPersonnel(orgStructId = '', exercise = null): Observable<any[]> {
    if (orgStructId === '') {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk
    }
    let params: any = {};
    if (exercise) {
      params.exercise = exercise;
    }
    return this.http.get<any[]>(environment.base_URL + `/personnel-predictions/organizational/${orgStructId}`, { params })
  }

  /**
   * Get personnel prediction by id
   */
  getPersonnelById(personnelId): Observable<any[]> {
    return this.http.get<any[]>(environment.base_URL + `/personnel-predictions/${personnelId}`)
  }

  /**
   * Create a prediction personnel
   */
  newPersonnel(personnel) {
    return this.http.post(environment.base_URL + "/personnel-predictions", personnel);
  }

  /**
   * Get personnel template
   * @param orgStructId 
   */
  getPersonnelTemplate(orgStructId): Observable<any[]> {
    if (!orgStructId) {
      orgStructId = this.authService.getUserMainSO()[0].idOrganizationalStructurePk;
    }
    return this.http.get<any[]>(environment.base_URL + `/personnel-predictions/template/${orgStructId}`)
  }
}
